import { render, staticRenderFns } from "./PropertyComments.vue?vue&type=template&id=0ac59823&scoped=true"
import script from "./PropertyComments.vue?vue&type=script&lang=js"
export * from "./PropertyComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac59823",
  null
  
)

export default component.exports